<template>
    <b-row :id="'chunkrow_'+chunk.id">
      <b-col>
        <b-card no-body>
          <b-card-body>
            <PublicationInfo :chunk="chunk"/>
            <ChunkContent :chunks="chunks" :filter="filter" :prevButton="showPrevButton" :nextButton="showNextButton" :isEaf="isEaf" @getChunk="getChunk"/>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col v-if="chunk.publication.type.name == 'PARALEL'">
        <b-card no-body>
          <b-card-body>
            <PublicationInfo :chunk="chunk.translate"/>
            <ChunkContent :chunks="chunks.map(c => c.translate)" :filter="filter" :prevButton="showPrevButton" :nextButton="showNextButton" :isEaf="isEaf" @getChunk="getChunk"/>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>
</template>

<script>
import PublicationInfo from './PublicationInfo'
import ChunkContent from './ChunkContent'

import { searchService } from '@/_services'

export default {
  name: "chunk",
  components:{
    PublicationInfo,
    ChunkContent
  },
  mounted() {

  },
  methods: {
    
  },
  props: {
      chunk: {
          type: Object,
          default: null
      },
      filter: {
          type: Object,
          default: null
      }
  },

  data(){
    return {
      chunks: [],
      prevButton: true,
      nextButton: true
    }
  },

  computed: {
    isEaf(){
      return this.chunk.publication.file.toLowerCase().endsWith('.eaf')
    },
    showPrevButton(){
      // if (this.chunk.publication.type.name == 'PARALEL') return false
      return this.chunk.number > 0 && this.prevButton
    },
    showNextButton(){
      // if (this.chunk.publication.type.name == 'PARALEL') return false
      return this.nextButton
    }
  },

  mounted() {
    this.chunks = []
    this.chunks.push(this.chunk)
  },

  methods: {
    getChunk(mode){
      searchService.getChunk(this.chunk,mode)
      .then(
        data => {
          
          if (mode == -1) {
            this.prevButton = false;

            data.chunkwords[data.chunkwords.length-1].hasSpace = true;
            let brCount = data.chunkwords.filter(word => word.type == 'linebreak').length;
            let curBrCount = this.chunk.chunkwords.filter(word => word.type == 'linebreak').length;
            if (brCount == 3 || curBrCount == 3) {
              data.push({type:'linebreak'});
              data.push({type:'linebreak'});
            } else if (this.chunk.newline || data.dialog) {
              data.chunkwords.push({type:'linebreak'});
            }

            this.chunks.unshift(data)

          } else if (mode == 1) {
            this.nextButton = false;

            this.chunk.chunkwords[this.chunk.chunkwords.length-1].hasSpace = true;
            let brCount = data.chunkwords.filter(word => word.type == 'linebreak').length;
            let curBrCount = this.chunk.chunkwords.filter(word => word.type == 'linebreak').length;
            if (brCount == 3 || curBrCount == 3) {
              data.unshift({type:'linebreak'});
            } else if (data.newline || data.dialog) {
              data.push({type:'linebreak'});
            }

            this.chunks.push(data)
          }
        }
      ).catch(error => {
        if (mode == -1) this.prevButton = false;
        else if (mode == 1) this.nextButton = false;
      })
    }
  }
}
</script>